module.exports = __webpack_public_path__ + "static/media/replacement-metal-castings.92ab36f6.png";